namespace TabAurous.Retail {
    export interface GiftVoucherSalesForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        EmployeeId: Serenity.LookupEditor;
        ItemDetails: GiftVoucherSalesDetailsEditor;
        ReceiptDetails: GiftVoucherSalesReceiptEditor;
        TotalAmount: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
    }

    export class GiftVoucherSalesForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.GiftVoucherSales';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherSalesForm.init)  {
                GiftVoucherSalesForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.LookupEditor;
                var w5 = GiftVoucherSalesDetailsEditor;
                var w6 = GiftVoucherSalesReceiptEditor;
                var w7 = s.DecimalEditor;

                Q.initFormType(GiftVoucherSalesForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'POSCustomerId', w3,
                    'EmployeeId', w4,
                    'ItemDetails', w5,
                    'ReceiptDetails', w6,
                    'TotalAmount', w7,
                    'UserId', w4
                ]);
            }
        }
    }
}
